import { callApi } from '../../../../../../apiCaller';
import { toastError } from '../../../../../../utils';

export const SET_WAIT_LIST = 'setAdminWaitList';

const API_SYSTEM_ADMIN_SEAT_WAIT_LIST_DATA_LISTS = 'seat/wait-list/data-lists';

export const setAdminWaitListLinks = (items) => {
     return {
          type: SET_WAIT_LIST,
          payload: items,
     };
};

export const fetchAdminWaitListLinksRequest = (paginationPayload, setIsLoading) => (dispatch) => {
     const { filter, page, pageSize, sortBy, sortType } = paginationPayload;
     const filterQuery = Object.keys(filter).length ? `&filter=${encodeURIComponent(JSON.stringify(filter))}` : '';

     const endPoint = `${API_SYSTEM_ADMIN_SEAT_WAIT_LIST_DATA_LISTS}?page=${page}&pageSize=${pageSize}&sortBy=${sortBy}&sortType=${sortType}${filterQuery}`;

     setIsLoading(true);

     callApi(endPoint, 'GET')
          .then((response) => {
               if (response.status !== 200) {
                    toastError(response);
                    return;
               }

               dispatch(setAdminWaitListLinks(response.data));
          })
          .finally(() => {
               setIsLoading(false);
          });
};
